import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const ProductionFeedEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [ordersLists, setOrdersLists] = useState([]);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [permission, setPermission] = useState({});
   let season_id = localStorage.getItem("season_id");


  useEffect(() => {
  

    axios
      .get(`/production-feeds/edit/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          toast.error(response.data.data.production);
          setValue(response.data.data.production);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: value.id,
      season_id: season_id,
      date_time: value.date_time,
      shift: value.shift,
      palletesation: value.palletesation,
    },
    enableReinitialize: true,
    onSubmit: (values,{ setSubmitting }) => {
      axios
        .post("/production-feeds/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
         // actions.setSubmitting(false);
          $("#form-submit").text("Update Production Feed");
          if (response.data.code === 200) {
            
            toast.success(response.data.message);
           // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/production-feeds";
            }, 1000);
          }  else if (response.data.code === 422) {
            setSubmitting(false);
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setSubmitting(false);
            setBackendErrors(response.data.error);
          }
          else {
            setSubmitting(false);
             setBackendErrors(response.data.error);
          }

        })
        .catch((error) => {
          console.log(error);
          //actions.setSubmitting(false);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
        setPermission(FindModuleById(71)); 
      console.log(permission);
    let para ={season_id:season_id};
    axios
      .post("/raw-materials-palletesation/listing",para, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let orders = response.data.data.palletisation;
          let productslisting = orders.map((shipp, index) => ({
            value: shipp.raw_id,
            label: shipp.barcode +' ('+shipp.lot_number+')',
            key: `farmer-${index}`,
          }));
          setOrdersLists(productslisting);
        } else {
          toast.error("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Feeds</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-feeds">Production Feeds</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Edit Production Feeds
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.update == 1 && (
                  <div className="card-body">
                    <h4 className="card-title">Production Feed Info</h4>
                     <FormikProvider value={formik}>
                     <form action="#" onSubmit={formik.handleSubmit}>
                      <div className="row">
                      <div className="col-md-4">
                          <div className="form-group order status">
                            <label>Palletesation</label>
                            {ordersLists.length > 0 && (
                              <Select
                              className="w-100"
                              value={ordersLists.find(option => option.value == formik.values.palletesation) || null} // Ensure correct format
                              name="palletesation"
                              onChange={(selectedOption) => {
                              handleSelectChange("palletesation", selectedOption);
                            //   generateLotNumberLocation(selectedOption.value);
                              }}
                              onBlur={formik.handleBlur}
                              options={ordersLists}
                              placeholder="Select"
                            />
                            )}
                            
                          </div>
                          <small>
                            {backendErrors.palletesation && (
                              <span className="form-error mt-1">
                                {backendErrors.palletesation}
                              </span>
                            )}
                          </small>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Date Time</label>
                            <input
                              type="datetime-local"
                              name="date_time"
                              className="form-input form-control"
                              value={formik.values.date_time}
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                               // setCurrentDateTime(e.target.value);
                        
                              }} 
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.date_time && (
                                <span className="form-error mt-1">
                                  {backendErrors.date_time}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Shift (1 or 2)</label>
                            <input
                               type="text"
                               onKeyPress={(event) => {
                                 // Allow only numbers (0-9)
                                 if (!/^[0-9]$/.test(event.key)) {
                                 event.preventDefault();
                                 }
                               }}
                               name="shift"
                              value={formik.values.shift}
                              className="form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                                //setCurrentDateTime(e.target.value);
                        
                              }} 
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.shift && (
                                <span className="form-error mt-1">
                                  {backendErrors.shift}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                  
                      </div>
                      <small>
                          {backendErrors.status  && (
                            <span className="form-error mt-1">
                              {backendErrors.status}
                            </span>
                          )}
                        </small>
                      <div className="text-end mt-4">
                        <button
                          type="submit" id="form-submit"
                          className="btn btn-primary"
                          disabled={formik.isSubmitting}
                        >
                          Update Production Feed
                        </button>
                      </div>
                    </form>
                     </FormikProvider>
                   
                  </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionFeedEdit;
